/**
 * templates/categories/admin.js - Admin Page Section Templates
 * 
 * Templates for admin-only pages that are self-managed by the Page Builder.
 * These templates render dynamic admin content (page lists, settings, etc.)
 * 
 * Total: 3 templates
 * - admin_pages_list: Page registry list (for PAGE_BUILDER_INDEX)
 * - admin_settings_panel: Site settings panel
 * - admin_stats_dashboard: Admin statistics dashboard
 */

import { LayoutPreset } from '../../layout/presets';
import { BackgroundType } from '../../layout/backgrounds';

const adminTemplates = {
  /**
   * Admin Pages List - Renders the page registry as a section
   * Used by PAGE_BUILDER_INDEX for recursive self-editing
   */
  admin_pages_list: {
    id: 'admin_pages_list',
    name: 'Admin Pages List',
    description: 'Displays the page registry with search, filters, and page cards',
    category: 'admin',
    thumbnail: null,
    
    // Default layout
    defaultLayout: {
      preset: LayoutPreset.SINGLE,
    },
    
    // Default background
    defaultBackground: {
      type: BackgroundType.NONE,
    },
    
    // Allowed customizations
    allowedLayouts: [LayoutPreset.SINGLE],
    allowedBackgrounds: [BackgroundType.NONE, BackgroundType.SOLID],
    maxBlocks: 1, // Only one pages list per page
    
    // Card variant (if applicable)
    defaultCardVariant: null,
    
    // Default props
    defaultProps: {
      title: 'All Pages',
      showStats: true,
      showSearch: true,
      showFilters: true,
      defaultFilter: 'all', // all, public, admin-only
      defaultView: 'grid', // grid, list
    },
    
    // Dynamic data source
    dataSource: {
      type: 'api',
      endpoint: '/api/admin/page-registry',
      cacheKey: 'page_registry',
    },
    
    // System section - cannot be removed from PAGE_BUILDER_INDEX
    isSystem: true,
  },
  
  /**
   * Admin Settings Panel - Site settings in a section
   */
  admin_settings_panel: {
    id: 'admin_settings_panel',
    name: 'Admin Settings Panel',
    description: 'Site-wide settings and configuration options',
    category: 'admin',
    thumbnail: null,
    
    defaultLayout: {
      preset: LayoutPreset.SINGLE,
    },
    
    defaultBackground: {
      type: BackgroundType.NONE,
    },
    
    allowedLayouts: [LayoutPreset.SINGLE],
    allowedBackgrounds: [BackgroundType.NONE],
    maxBlocks: 1,
    
    defaultProps: {
      title: 'Site Settings',
      sections: ['general', 'branding', 'features'],
    },
    
    isSystem: true,
  },
  
  /**
   * Admin Stats Dashboard - Statistics overview
   */
  admin_stats_dashboard: {
    id: 'admin_stats_dashboard',
    name: 'Admin Stats Dashboard',
    description: 'Overview of site statistics and metrics',
    category: 'admin',
    thumbnail: null,
    
    defaultLayout: {
      preset: LayoutPreset.SINGLE,
    },
    
    defaultBackground: {
      type: BackgroundType.NONE,
    },
    
    allowedLayouts: [LayoutPreset.SINGLE],
    allowedBackgrounds: [BackgroundType.NONE],
    maxBlocks: 1,
    
    defaultProps: {
      title: 'Dashboard',
      metrics: ['users', 'content', 'engagement'],
      timeRange: '7d',
    },
    
    isSystem: true,
  },
};

export default adminTemplates;
